import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取角色列表
export function getPrivilegeGroupList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.store.privilegeGroup',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加角色
export function savePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.savePrivilegeGroup',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新角色
export function updatePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.updatePrivilegeGroup',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除角色
export function deletePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.deletePrivilegeGroup',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}